import React from 'react';
import CreationStep from './CreationSteps/creationStep';
import StoryLineStep from './CreationSteps/storyLineStep';
import SettingVibeStep from './CreationSteps/settingVibeStep';
import TemplateSelectionStep from './CreationSteps/templateSelectionStep';

/**
 * Step configuration mapping
 * Maps step numbers to their corresponding components and metadata
 */
export const STEP_CONFIG = {
  1: {
    component: CreationStep,
    name: 'creation',
    label: 'Creation Page',
    showHeader: true,
    showBackButton: false
  },
  2: {
    component: StoryLineStep,
    name: 'storyline',
    label: 'Story Line',
    showHeader: true,
    showBackButton: true
  },
  // 3: {
  //   component: SettingVibeStep,
  //   name: 'setting-vibe',
  //   label: 'Setting Vibe',
  //   showHeader: true,
  //   showBackButton: true
  // },
  // 4: {
  //   component: TemplateSelectionStep,
  //   name: 'template-selection',
  //   label: 'Choose Template',
  //   showHeader: true,
  //   showBackButton: true
  // }
};

/**
 * Renders the appropriate step component based on current step
 * @param {number} currentStep - Current step number (1-4)
 * @param {object} props - Props to pass to step component
 * @returns {React.Component} The rendered step component
 */
export function renderStepComponent(currentStep, props = {}) {
  const stepConfig = STEP_CONFIG[currentStep] || STEP_CONFIG[1];
  
  if (!STEP_CONFIG[currentStep]) {
    console.warn(`Invalid step: ${currentStep}. Falling back to step 1.`);
  }

  const StepComponent = stepConfig.component;
  return <StepComponent {...props} />;
}

/**
 * Gets step configuration metadata
 * @param {number} step - Step number
 * @returns {object} Step configuration object
 */
export function getStepConfig(step) {
  return STEP_CONFIG[step] || STEP_CONFIG[1];
}
